import {useJbHttpCrudService} from "../../core/service/jb-http-crud.service";
import {ProcessStageEntity} from "../entity/process-stage.entity";

export function useProcessStageRepository() {
  const crud = useJbHttpCrudService<ProcessStageEntity>('process-stage')
  
  return {
    ...crud
  }
}